import React from "react";
import { Icon } from "@iconify/react";
import closeIcon from "@iconify/icons-mdi/close";
import '../../../styles/Auth/categoryPopup.css';

const ViewCategoryPopup = ({ data, onClose }) => {
    return (
        <div className="view-popup-overlay">
            <div className="view-popup-wrapper">
                {/* <Icon
                    icon={closeIcon}
                    className="popup-close-icon"
                     onClick={onClose}
                /> */}
                <div className="category-view-popup-card">
                    <h6 className="category-view-popup-title">Category Details</h6>

                    <div className="view-popup-info">

                        {/* Image Section */}
                        <div className="category-view-image-wrapper">
                            <img
                                src={
                                    data?.categoryImageObject?.uri
                                        ? `${process.env.REACT_APP_API_URL}${data.categoryImageObject.uri}`
                                        : "/assets/placeholder.png"
                                }
                                alt="Category"
                                className="category-view-popup-image"
                            />
                        </div>

                        {/* Info Section */}
                        <div className="category-info">
                            <table className="category-info-table">
                                <tbody>
                                    <tr>
                                        <th>Category Name</th>
                                    </tr>
                                    <tr>
                                        <td>{data.categoryName}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Close Button */}
                        <div className="category-view-action">
                            <button className="category-Done-Button" onClick={onClose}>Close</button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );

};

export default ViewCategoryPopup;
